import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
    import { useInitials } from '@/composables/useInitials';
    import type { User } from '@/types';
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeAvatar',
  props: {
    user: {},
    class: {}
  },
  setup(__props: any) {

    const { getInitials } = useInitials();

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Avatar), {
    class: _normalizeClass(_unref(cn)('border-foreground size-6', props.class))
  }, {
    default: _withCtx(() => [
      (_ctx.user && _ctx.user.avatar)
        ? (_openBlock(), _createBlock(_unref(AvatarImage), {
            key: 0,
            src: _ctx.user.avatar,
            alt: _ctx.user.name
          }, null, 8, ["src", "alt"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(AvatarFallback), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(getInitials)(_ctx.user?.name)), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})